import MuiButton from '@material-ui/core/Button';
import { withThemeProvider } from './ThemeProvider';

export const Button = withThemeProvider(MuiButton);
